import { render, staticRenderFns } from "./ServicesCategories.vue?vue&type=template&id=1931f2e6&scoped=true&"
import script from "./ServicesCategories.vue?vue&type=script&lang=js&"
export * from "./ServicesCategories.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCategories.vue?vue&type=style&index=0&id=1931f2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931f2e6",
  null
  
)

export default component.exports